'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _iconStyle = require('./icon.style.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var X = function X(allProps) {
  var style = {
    width: '1em',
    height: '1em'
  };
  var className = allProps.className,
      props = (0, _objectWithoutProperties3.default)(allProps, ['className']);

  return _react2.default.createElement(
    'svg',
    (0, _extends3.default)({
      viewBox: '0 0 32 32',
      style: style,
      title: 'x icon',
      preserveAspectRatio: 'xMidYMid meet',
      className: (0, _classnames2.default)(_iconStyle.monoIconStyle, className)
    }, props),
    _react2.default.createElement('path', { d: 'M18 16L31.6 2.2a1 1 0 0 0 0-1.4l-.5-.5a1 1 0 0 0-1.4 0L16 14.1 2.2.3A1 1 0 0 0 .8.3L.3.8a1 1 0 0 0 0 1.4L14.1 16 .3 29.8a1 1 0 0 0 0 1.4l.5.5a1 1 0 0 0 1.4 0L16 17.9l13.8 13.8a1 1 0 0 0 1.4 0l.5-.5a1 1 0 0 0 0-1.4L17.9 16z'
    })
  );
};

exports.default = X;